import { ProjectDto } from '@/core';

export const validateEmployeesTab = (projectData: ProjectDto) => {
  return !!projectData.employees.length;
};
